import { Image } from '@chakra-ui/react';
import KleverLogo from '../../assets/klever_logo.svg';

export function Logo() {
  return <Image src={KleverLogo} w="9.375rem" m="auto" alt="Klever Logo" />;
}
